import { State } from '../../types';

export const massachusetts: State = {
  name: 'Massachusetts',
  abbreviation: 'MA',
  terms: [
    {
      word: 'Gloucester',
      phonetic: 'GLOSS-tuh',
      // audioUrl: '/audio/gloucester.mp3',
      description: 'Historic fishing city on Cape Ann'
    },
    {
      word: 'Haverhill',
      phonetic: 'Hay-vrill',
      // audioUrl: '/audio/gloucester.mp3',
      description: 'A city in Essex County'
    },
    {
      word: 'Leicester',
      phonetic: 'les-ter',
      // audioUrl: '/audio/leicester.mp3',
      description: 'Town in Massachusetts with a simplified pronunciation.'
    },
    {
      word: 'Leominster',
      phonetic: 'lem-in-ster',
      // audioUrl: '/audio/leominster.mp3',
      description: 'Commonly mispronounced town in Massachusetts.'
    },
    {
      word: 'Medford',
      phonetic: 'mef-id',
      // audioUrl: '/audio/medford.mp3',
      description: 'Often pronounced differently by locals.'
    },
    {
      word: 'Peabody',
      phonetic: 'pee-buh-dee',
      // audioUrl: '/audio/peabody.mp3',
      description: 'Town with a distinct local pronunciation.'
    },
    {
      word: 'Tewksbury',
      phonetic: 'tooks-berry',
      // audioUrl: '/audio/tewksbury.mp3',
      description: 'Town near Lowell with a mispronounced name.'
    },
    {
      word: 'Tremont Street',
      phonetic: 'treh-mont',
      // audioUrl: '/audio/tremont_street.mp3',
      description: 'Street name often pronounced differently.'
    },
    {
      word: 'Woburn',
      phonetic: 'woo-burn',
      // audioUrl: '/audio/woburn.mp3',
      description: 'Can also be pronounced "woo-bun" depending on the accent.'
    },
    {
      word: 'Worcester',
      phonetic: 'WUSS-tuh',
      audioUrl: '/audio/worcester.mp3',
      description: 'City in central Massachusetts'
    }
  ]
};
